import {StyleSheet} from 'react-native';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  titleImage: {
    width: 280,
    height: 76,
    left: 55,
  },
});

export default styles;
